import { useState, useEffect } from "react";
import clsx from "clsx";

import {
  CompanyProfileInformation,
  CompanyProfileInformationForm,
} from "@/components";

import { useGetCompanyInformation } from "@/hooks/queries";
import { Company } from "@/types";

export const CompanyProfile = ({
  className,
  company,
}: {
  className?: string;
  company: Company;
}) => {
  const { data, status } = useGetCompanyInformation();
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isEditing]);

  if (status === "pending") {
    // TODO: Loading state.
    return null;
  } else if (status === "error") {
    // TODO: Error state.
    return null;
  }

  return (
    <div className={clsx("flex flex-col gap-8", className)}>
      {isEditing ? (
        <CompanyProfileInformationForm
          company={company}
          companyInformation={data.companyInformation}
          setIsEditing={setIsEditing}
        />
      ) : (
        <CompanyProfileInformation
          company={company}
          companyInformation={data.companyInformation}
          setIsEditing={setIsEditing}
        />
      )}
    </div>
  );
};
